/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Terug_Naar_Admin_AriaInputs */

const nl_admin_terug_naar_admin_aria = /** @type {(inputs: Admin_Terug_Naar_Admin_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar admin`)
};

/**

* @param {Admin_Terug_Naar_Admin_AriaInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const admin_terug_naar_admin_aria = /** @type {((inputs?: Admin_Terug_Naar_Admin_AriaInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Terug_Naar_Admin_AriaInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_admin_terug_naar_admin_aria(inputs)
});
export { admin_terug_naar_admin_aria as "admin.terug_naar_admin_aria" }